import "./faq.css";
import { routes } from "../../routes";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaqHtml } from "../../api/modules/b2droppie.class";
import { toggleLoader } from "../../redux/slices/loaderSlice";
import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";
import { ReactComponent as FaqIcon } from "../../assets//icons/faqIcon.svg";

const FAQ = ({ limit = null, showLoadMore = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [faq, setFaq] = useState([]);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const isLoading = useSelector((state) => state?.loader?.isLoading);

  useEffect(() => {
    dispatch(toggleLoader({ isLoading: true }));
    try {
      FaqHtml()
        .then((response) => {
          setFaq(response?.data?.data || []);
          dispatch(toggleLoader({ isLoading: false }));
        })
        .catch((e) => {
          console.log(e);
          dispatch(toggleLoader({ isLoading: false }));
        });
    } catch (e) {
      console.log("Failed", e);
      dispatch(toggleLoader({ isLoading: false }));
    }
  }, [dispatch]);

  const displayedFaq = limit ? faq.slice(0, limit) : faq;

  const showButton = showLoadMore && faq.length > (limit || 0);

  return isLoading ? (
    <BackdropLoader show={isLoading} />
  ) : (
    <div className={`faq-container ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <div className="faq-inner-wrapper">

        {/* ── LEFT PANEL ── */}
        <div className="faq-left-panel">

          {/* Icon + Title on same row */}
          <div className="faq-title-row">
            <div className="faq-icon">
              <FaqIcon />
            </div>
            <h1 className="faq-title">Frequently Asked Questions</h1>
          </div>

          {/* Subtitle & Button indented to align under title text */}
          <div className="faq-content-indented">
            <p className="faq-subtitle">
              Have questions? Our FAQs cover everything you need to know, from how
              it works to rewards and payments so you can play with confidence and
              ease.
            </p>

            {/* Desktop button — hidden on mobile via CSS */}
            {showButton && (
              <button
                type="button"
                onClick={() => navigate(routes.FAQ)}
                className="faq-view-all-btn faq-view-all-btn--desktop"
              >
                View All Questions <i className="fa-solid fa-angles-right" />
              </button>
            )}
          </div>

        </div>

        {/* ── RIGHT PANEL ── */}
        <div className="faq-right-panel">
          <Accordion defaultActiveKey="0" flush>
            {displayedFaq?.map((faqItem, index) => (
              <Accordion.Item
                key={index}
                eventKey={String(index)}
                className="faq-item"
              >
                <Accordion.Header>
                  <span
                    className="faq-question"
                    dangerouslySetInnerHTML={{ __html: faqItem?.title }}
                  />
                </Accordion.Header>
                <Accordion.Body>
                  <div
                    className="faq-answer"
                    dangerouslySetInnerHTML={{ __html: faqItem?.content }}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>

      </div>

      {/* Mobile button — below accordion, full width, hidden on desktop via CSS */}
      {showButton && (
        <button
          type="button"
          onClick={() => navigate(routes.FAQ)}
          className="faq-view-all-btn faq-view-all-btn--mobile"
        >
          View All Questions <i className="fa-solid fa-angles-right" />
        </button>
      )}

    </div>
  );
};

export default FAQ;